import { z } from "zod";
import { DealStatus, IDealState } from "../interfaces/IDeal";

const dealValidationSchema = () => z.object({
    name: z.string().min(1),
    value: z.number().positive(),
    dealStageId: z.number().int().positive(),
    status: z.string().min(1),
    sourcingMethod: z.string().min(1),
    contactPersonName: z.string().min(1),
    zoning: z.string().min(1),
    buildingSize: z.number().nonnegative(),
    landSizeAcres: z.number().positive(),
    usableLand: z.number().positive().nullable(),
    OID: z.string().min(1),
    dropboxLink: z.string().min(1),
});

export default (isCreateMode: boolean = false) => (values: IDealState) => {
    const baseResult = dealValidationSchema().safeParse(values);
    const errors: Record<string, string> = {};

    if (!baseResult.success) {
        baseResult.error.issues.forEach((issue) => {
            const path = issue.path.join('.');
            errors[path] = issue.message;
        });
    }

    if (isCreateMode && !values.notes?.trim() && !values.attachments?.length) {
        errors.notes = "Either notes or attachments are required";
        errors.attachments = "Either notes or attachments are required";
    }

    if (values.status === DealStatus.Lost && !values.lostReason)
        errors.lostReason = "Lost reason is required";

    return errors;
};